import moment from 'moment';

import { Nullable } from '~globals/types/commons';
import { AdminReportUserSatisfactionFilters } from '~services/admin/report/types';

export const getPayloadGetReportUserSatisfactionData = ({
  currentPeriod,
  currentDriverId,
  currentAssociatedCompanyId,
}: {
  currentPeriod: Nullable<Date>;
  currentDriverId: Nullable<string>;
  currentAssociatedCompanyId: Nullable<string>;
}): AdminReportUserSatisfactionFilters => {
  const current = moment(currentPeriod);

  return {
    month: current.get('month') + 1,
    year: current.get('year'),
    driverId: currentDriverId,
    associatedCompanyId: currentAssociatedCompanyId,
  };
};
